var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "nonzero",
    d: "M3.412 4l2.3-2.294c.286-.286.37-.717.215-1.09C5.772.242 5.407 0 5.002 0c-.266 0-.52.104-.71.292l-4 4c-.39.39-.39 1.023 0 1.413l4 4c.252.257.623.36.97.267.348-.09.62-.362.713-.71.093-.347-.007-.718-.263-.97L3.414 6H17c.552 0 1-.448 1-1s-.448-1-1-1H3.41z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointArrowLeft);
export default __webpack_public_path__ + "static/media/point-arrow-left.fe670310d18127ec98478644938f1994.svg";
export { ForwardRef as ReactComponent };